<template>
  <div>
    <!-- preloader area start -->
    <!-- <div class="preloader" id="preloader">
        <div class="preloader-inner">
            <div class="spinner">
                <div class="dot1"></div>
                <div class="dot2"></div>
            </div>
        </div>
    </div> -->
    <!-- preloader area end -->

    <!-- singin-area start -->
    <div class="signin-area mg-top-90">
      <div class="container">
        <b-form validated @submit.prevent="handleSigninUser" autocomplete="new-password">
          <div class="signin-area-inner text-center">
            <img src="assets/img/other/2.png" alt="img">
            <h3>Let's Sign In</h3>
            <p>Welcome Back, you've been missed !</p>
            <!-- <div class="row mt-4 text-center">
            <div class="col"> <b-button type="submit" variant="ms2" class="" @click="handleSigninMS()">
                <b-img class="ms_signin"
                  :src="$store.state.darkMode ? '/img/brand/ms-symbollockup_signin_dark.png' : '/img/brand/ms-symbollockup_signin_light.png'"></b-img>
              </b-button></div>
          </div>

          <div class="or">
            <span>or</span>
          </div> -->

          </div>
          <!-- contact-form-inner -->
          <!-- <form class=""> -->
          <div class="row">
            <div class="col">
              <label class="single-input-wrap">
                <input type="email" id="normalEmail" required v-model="email" :disabled="busy"
                  placeholder="Enter Email">
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label class="single-input-wrap">
                <input type="password" id="normalPass" required v-model="password" :disabled="busy"
                  placeholder="Enter Password" autocomplete="new-password">
              </label>
            </div>
          </div>
          <div v-if="error">
            <b-alert variant="danger" show>{{ error.message }}</b-alert>
          </div>

          <div class="form-check">
            <div class="row">
              <div class="col">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                <label class="form-check-label" for="flexCheckDefault">
                  Remember Me
                </label>
              </div>
              <div class="col" style="text-align:right">
                <router-link class="pl-0" to="/reset?action=forgot">Forgot
                  password?</router-link>
              </div>
            </div>
          </div>


          <b-row align-v="center" no-gutters>
            <b-col>
              <button type="submit" class="btn-c btn-success mr-1 mb-2 btn-large w-100" @click="handleSigninUser()">Sign
                in</button>
              <!-- <b-button type="submit" variant="blue" class="btn-large btn-blue w-100 radius-50"
                @click="handleSigninUser()">Sign in</b-button>&nbsp; -->
              <img v-show="busy"
                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            </b-col>
          </b-row>
        </b-form>

        <!-- <a class="btn-large btn-blue w-100" href="user-verification.html">Sign In</a> -->
        <!-- <div class="text-center">
            <p>Already have not an account? <a href="signup.html">Sign up !</a></p>
          </div> -->
        <!-- </form> -->
      </div>
    </div>
    <!-- singin-area End -->

  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Signin",
  data() {
    return {
      message: null,
      email: "",
      password: "",
      account: null,
      showcredentials: false
    };
  },
  computed: {
    ...mapGetters(["busy", "error", "user"]),
  },
  watch: {
    user(value) {
      // if user value changes, redirect to home page
      if (value) {
        this.$router.push("/");
      }
    },
  },
  methods: {
    async handleSigninMS() {
      this.$store.dispatch("signinMS")
    },
    handleSigninUser() {
      this.$store.dispatch("signinUser", {
        email: this.email,
        password: this.password,
      });
    },
  },
};
</script>
